import { render, staticRenderFns } from "./RiskImage.vue?vue&type=template&id=44aca235&"
import script from "./RiskImage.vue?vue&type=script&lang=js&"
export * from "./RiskImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports